

















import { defineComponent } from '@vue/composition-api';
import { Group } from '@/store/types';

export default defineComponent({
	components: {},
	props: {
		group: {
			type: Object as () => Group,
			required: true,
		},
	},
	setup({ group }) {
		const groupLink = `/groups/${group.id}`;

		return {
			groupLink,
		};
	},
});
